// @flow
import type { Auction } from '../auction/types'
import type { ShippingOption } from '../checkout'
import { compose, withProps } from 'recompose'
import PickupOptions from '../../ui/views/pickup-options'
import { AUCTION_SHIPPING_OPTION } from '../auction/constants'
import { formatDateShort } from '../../core/dateFormater'
import withItemAuctionData from './withItemAuctionData'
import withTranslations from '../../core/withTranslations'

const selectShippingOptionInfoText = (
  shippingOption: ShippingOption
): string => {
  switch (shippingOption) {
    case AUCTION_SHIPPING_OPTION.NATIONAL:
      return 'app:item.aboutShipping.shippingOptionNationalInfo'
    case AUCTION_SHIPPING_OPTION.WORLDWIDE:
      return 'app:item.aboutShipping.shippingOptionWorldwideInfo'
    default:
      return 'app:item.aboutShipping.shippingOptionNoneInfo'
  }
}

const withPresentationProps = withProps(({ auction }: Object): Object => {
  const {
    closeTime,
    pickUpAtCharity,
    pickUpAtEvent,
    shippingOption,
    pickUpAtEventMaxTime
  }: Auction = auction
  const closeDate = formatDateShort(closeTime)
  return {
    hasPickUpAtCharityOption: Boolean(pickUpAtCharity),
    hasPickUpAtEventOption: Boolean(pickUpAtEvent),
    hasHomeDeliveryOption: Boolean(shippingOption),
    pickUpAtEventDatetime:
      closeDate &&
      pickUpAtEventMaxTime &&
      `${closeDate} at ${pickUpAtEventMaxTime}`
  }
})

const translations = withTranslations(props => ({
  shippingOptionsTitleText: 'app:item.aboutShipping.shippingOptionsTitle',
  pickUpAtEventTitleText: 'app:item.aboutShipping.pickUpAtEventTitle',
  pickUpAtEventInfoText: 'app:item.aboutShipping.pickUpAtEventInfo',
  pickUpAtCharityTitleText: 'app:item.aboutShipping.pickUpAtCharityTitle',
  pickUpAtCharityInfoText: 'app:item.aboutShipping.pickUpAtCharityInfo',
  shippingOptionTitleText: 'app:item.aboutShipping.shippingOptionTitle',
  shippingOptionInfoText: selectShippingOptionInfoText(
    props.auction.shippingOption
  )
}))

export const AboutShippingEnhancer = compose(
  withItemAuctionData,
  withPresentationProps,
  translations
)

export default AboutShippingEnhancer(PickupOptions)



// WEBPACK FOOTER //
// ./src/services/item/AboutShipping.js